import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { Button } from "components/atoms/button/index";
import { PracticeName, AgentDetails, AgentDependsMapper } from "./constants";
// import { Header } from "components/atoms/header/index";
import * as S from "./preferences.styles";
import { Field } from "components/molecules/Field";
import { UserService } from "core/service/user.service";
import { UtilService } from "core/utils/utils";

export const Preferences = () => {
  const { t } = useTranslation();
  const [taxAgent, setTaxAgent] = useState();
  const [nonTaxAgent, setNonTaxAgent] = useState();
  const [accountant, setAccountant] = useState(false);
  const [accountantDetails, setAccountantDetails] = useState({});
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onBlur" });

  const getAgentPreferencesFields = () => {
    UserService.getpreferences("agent").then((res) => {
      if (res && Object.keys(res.payload).length) {
        accountantFieldMapper(res.payload);
      }
    });
  };

  const getAgentDetails = () => {
    UserService.getagentdetails().then((res) => {
      if (res && Object.keys(res.payload).length) {
        setAccountant(true);
        setAccountantDetails(res.payload);
        reset(res.payload);
      }
    });
  };

  const accountantFieldMapper = (value) => {
    const result = UtilService.convertDynamicdatatoFields(value);
    const agentField = result.slice(0, 2);
    const field = agentField.map((item, index) => {
      item["depends"] = AgentDependsMapper[index];
      return item;
    });
    setTaxAgent([field[1]]);
    setNonTaxAgent([field[0]]);
  };

  useEffect(() => {
    getAgentPreferencesFields();
    getAgentDetails();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const onSubmit = (values) => {
    if (accountant) {
      UserService.updateagentdetails(values).then(() => {
        getAgentDetails();
      });
    } else {
      if (!accountant && Object.keys(accountantDetails).length > 0) {
        UserService.deleteagentdetails().then(() => {
          getAgentDetails();
        });
      } else {
        toast.error("No changes were made");
      }
    }
  };

  const toggleAccountant = (e) => {
    setAccountant(accountant ? !e : e);
  };

  return (
    <div>
      {/* <Header /> */}
      <S.Container>
        <S.Form onSubmit={handleSubmit(onSubmit)}>
          {/* <S.CardHeader>{t("preferences.header")}</S.CardHeader> */}
          <S.CheckboxContainer>
            {nonTaxAgent
              ? nonTaxAgent.map((obj) => (
                  <Field
                    key={obj.name}
                    small
                    {...obj}
                    checked={!accountant}
                    onchange={toggleAccountant}
                    register={register}
                    error={errors[obj.name]?.message}
                  />
                ))
              : ""}
          </S.CheckboxContainer>
          <S.CheckboxContainer>
            {taxAgent
              ? taxAgent.map((obj) => (
                  <Field
                    key={obj.name}
                    small
                    {...obj}
                    checked={accountant}
                    onchange={toggleAccountant}
                    register={register}
                    error={errors[obj.name]?.message}
                  />
                ))
              : ""}
          </S.CheckboxContainer>
          {accountant ? (
            <div>
              <S.SplitContainer>
                {AgentDetails.map((obj) => (
                  <Field
                    key={obj.name}
                    background="grey"
                    font="small"
                    {...obj}
                    register={register}
                    error={errors[obj.name]?.message}
                  />
                ))}
              </S.SplitContainer>
              <S.SplitContainer>
                {PracticeName.map((obj) => (
                  <Field
                    key={obj.name}
                    background="grey"
                    font="small"
                    {...obj}
                    register={register}
                    error={errors[obj.name]?.message}
                  />
                ))}
              </S.SplitContainer>
            </div>
          ) : (
            ""
          )}
          <S.ButtonContianer>
            <Button value={t("preferences.button")} />
          </S.ButtonContianer>
        </S.Form>
      </S.Container>
    </div>
  );
};
